var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "modal fade show d-block",
            attrs: { tabindex: "-1", role: "dialog" }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-lg",
                attrs: { role: "document" }
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("CO2 Emission Details")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: { click: _vm.closeModal }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.emission
                    ? _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h6", { staticClass: "text-primary" }, [
                              _vm._v("Vehicle Information")
                            ]),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-sm table-borderless"
                              },
                              [
                                _c("tr", [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.chassis_number || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.emission.make || "-"))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.emission.model || "-"))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.emission.year || "-"))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.industry_code || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.emission.variant || "-"))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.emission.class || "-"))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.emission.tare || "-"))
                                  ])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h6", { staticClass: "text-primary" }, [
                              _vm._v("Engine & Emissions")
                            ]),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-sm table-borderless"
                              },
                              [
                                _c("tr", [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.engine_type || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(9),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.cc_rating || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(10),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.transmission || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.test_cycle || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission
                                          .current_emission_standard || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.co2_3pwltp || "-")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.emission.ccs_weight || "-")
                                    )
                                  ])
                                ])
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h6", { staticClass: "text-primary" }, [
                              _vm._v("CO₂ Differences")
                            ]),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-sm table-borderless"
                              },
                              [
                                _c("tr", [
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission.co2_difference_2024 || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(16),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission.co2_difference_2025 || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.emission.co2_difference_notes
                                  ? _c("tr", [
                                      _vm._m(17),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.emission.co2_difference_notes
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h6", { staticClass: "text-primary" }, [
                              _vm._v("Fleet Average Charges")
                            ]),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-sm table-borderless"
                              },
                              [
                                _c("tr", [
                                  _vm._m(18),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission
                                          .fleet_average_charge_2024 || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(19),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission
                                          .fleet_average_charge_2025 || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(20),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission.fleet_average_rate || "-"
                                      )
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h6", { staticClass: "text-primary" }, [
                              _vm._v("Pay As You Go Charges")
                            ]),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-sm table-borderless"
                              },
                              [
                                _c("tr", [
                                  _vm._m(21),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission
                                          .pay_as_you_go_charge_2024 || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(22),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission
                                          .pay_as_you_go_charge_2025 || "-"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(23),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.emission.pay_as_you_go_rate || "-"
                                      )
                                    )
                                  ])
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.closeModal }
                      },
                      [_vm._v("Close")]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.show ? _c("div", { staticClass: "modal-backdrop fade show" }) : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Chassis Number:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Make:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Model:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Year:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Industry Code:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Variant:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Class:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Tare:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Engine Type:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("CC Rating:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Transmission:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Test Cycle:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Current Emission Standard:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("CO₂ 3PWLTP:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("CCS Weight:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("CO₂ Difference (2024):")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("CO₂ Difference (2025):")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("CO₂ Difference Notes:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Charge (2024):")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Charge (2025):")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Rate:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Charge (2024):")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Charge (2025):")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Rate:")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f58f3770", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f58f3770","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Co2Emissions/EmissionModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f58f3770","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Co2Emissions/EmissionModal.vue
// module chunks = 0